import $ from 'jquery'
// import { breakpoints } from './_site';
import { create as initSlider } from './slider'

export const timeout = {}
export const createSlider = ($el) => {
  var isSingle = $el.is('.promobanner'),
    options = {
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 7000,
    }

  if (isSingle) {
    options.slidesToShow = 1
    options.slidesToScroll = 1
  }

  initSlider($el, options)
}
export const binds = () => {
  createSlider($('.promobanner'))
}
